import { RouteType } from "types/RouteType";

const companiesRoute: RouteType = {
  name: "MM Companies",
  path: "/mm/companies",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Companies",
      component: () => import("./Companies.Header"),
      enableRefreshButton: false,
      enableBackButton: false,
    },
    body: {
      component: () => import("./Companies.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 8,
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "Add Company",
      title: "Add Company",
      component: () => import("./CompaniesDialogs/CompanyFormDialog"),
    },
    {
      name: "Edit Company",
      title: "Edit Company",
      component: () => import("./CompaniesDialogs/CompanyFormDialog"),
    },
    {
      name: "Add Contact",
      title: "Add Contact",
      component: () => import("./CompaniesDialogs/ContactFormDialog"),
    },
    {
      name: "Edit Contact",
      title: "Edit Contact",
      component: () => import("./CompaniesDialogs/ContactFormDialog"),
    },
  ],
};

export default companiesRoute;
